// extracted by mini-css-extract-plugin
export var searchHeader = "_at-0";
export var searchHeaderDark = "_at-1";